import { createTheme } from '@mui/material';

/**
 * Kolory z theme/_color.scss – używane w komponentach MUI (sx).
 * Zgodność z globalnymi kolorami SCSS.
 */
const appPalette = {
  // Bazy
  white: '#ffffff',
  black: '#000000',
  // Tekst
  textPrimary: '#383a3c',
  textSecondary: '#717378',
  textMuted: '#697586',
  textMutedAlpha: 'rgba(105, 117, 134, 0.5)',
  // Tła
  greyBackground: '#f3f4f7',
  greyBackgroundDark: '#e7e9ee',
  hoverBg: 'rgba(13, 18, 28, 0.04)',
  // Obramowania
  border: '#dbdee4',
  borderLight: '#cccfd5',
  tableBorder: '#ddd',
  collapsedBorder: '#d9d9d9',
  // Akcenty
  orangeHover: '#EF6C00',
  secondaryLight: '#512DA8',
  // Statusy / badge
  badgeWarning: '#FFC107',
  badgeSuccess: '#4CAF50',
  badgeError: '#D32F2F',
  // Inne
  success: '#44d038',
  greyBorder: '#CCCFD5',
  colorOrange: '#ff8c39'
};

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1600
    }
  },
  palette: {
    primary: {
      main: '#173EC7'
    },
    secondary: {
      main: '#4917C7'
    },
    error: {
      main: '#c71717'
    },
    warning: {
      main: '#856404'
    },
    success: {
      main: '#44d038'
    },
    text: {
      primary: '#383a3c',
      secondary: '#717378',
      disabled: '#8d9096'
    },
    background: {
      default: '#fff',
    },
    divider: '#dbdee4',
    /** Kolory aplikacji (zgodne z theme/_color.scss) – do użycia w sx: theme.palette.app.xxx */
    app: appPalette
  }
});
